// Spawn `gh auth login --hostname github.com --web` interactive.
// User sẽ thấy device-code prompt và browser tự mở. Block đến khi xong.
import { spawnSync } from "node:child_process";
import { log } from "./terminal-logger.js";

export function triggerGhCliAuthLogin(): void {
  log.info("Khởi động đăng nhập GitHub qua gh CLI (browser sẽ mở)...");
  const r = spawnSync(
    "gh",
    ["auth", "login", "--hostname", "github.com", "--web", "--git-protocol", "ssh"],
    { stdio: "inherit" },
  );
  if (r.status !== 0) {
    throw new Error(`gh auth login thất bại (exit ${r.status}). Thử 'gh auth login' tay.`);
  }
  log.success("Đã đăng nhập GitHub");
}
